import React, { useEffect, useState } from "react";
import { Container, Card } from "react-bootstrap";
import ImageHand from "../../assets/hands.png";
import ImageKing from "../../assets/king.png";
import { useNavigate } from "react-router-dom";
import "../../components/return/return.css";
import "./memberRight.css";

const MemberRight = (props) => {

  const [currentPage, setCurrentPage] = useState(0);
  let touchStartY = 0;
  let touchEndY = 0;

  useEffect(() => {
    const handleScroll = (event) => {
      if (event.deltaY > 0) {
        setCurrentPage((prevPage) => Math.min(prevPage + 1, 1));
      } else {
        setCurrentPage((prevPage) => Math.max(prevPage - 1, 0));
      }
    };

    const handleTouchStart = (event) => {
      touchStartY = event.touches[0].clientY;
    };

    const handleTouchEnd = (event) => {
  touchEndY = event.changedTouches[0].clientY; 
  if (touchStartY - touchEndY > 50) {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, 1));
  } else if (touchEndY - touchStartY > 50) {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 0));
  }
};

    const handleTouchMove = (event) => {
      touchEndY = event.changedTouches[0].clientY;
    };

    window.addEventListener("wheel", handleScroll);
    window.addEventListener("touchstart", handleTouchStart);
    window.addEventListener("touchmove", handleTouchMove);
    window.addEventListener("touchend", handleTouchEnd);

    return () => {
      window.removeEventListener("wheel", handleScroll);
      window.removeEventListener("touchstart", handleTouchStart);
      window.removeEventListener("touchmove", handleTouchMove);
      window.removeEventListener("touchend", handleTouchEnd);
    };
  }, []);


  return (
    <>
      <section
        style={{ minHeight: "100vh", overflow: "auto", background: "#56ACAE" }}
      >
        <Container fluid style={{ height: "100%" }}>
          <div style={{ height: "45vh" }}>
            <div
              className="memberRight-custom-style"
              style={{ letterSpacing: "5px" }}
            >
              <div className="w-100 text-center memberRight-title-words">
                <b>加入元大官方帳號</b>
                <br />
                <b>您將享有 . . .</b>
                <img
                  src={ImageHand}
                  alt="hand"
                  className="memberRight-image"
                />
              </div>
            </div>
            <div>
              <Card className="memberRight-cardo mt-4 shadow ">
                <div className="d-flex flex-column align-items-center justify-content-between p-3 m-3 ">
                  <div className="memberRight-card-passage">
                    <b>✔訪問官方頁面</b>
                  </div>
                  <div className="memberRight-card-passage">
                    <b>✔下載操作手冊</b>
                  </div>
                  <div className="memberRight-card-passage">
                    <b>✔元大智能客服</b>
                  </div>
                </div>
              </Card>
            </div>
          </div>
          <hr style={{ border: 'none', borderTop: '1px dashed white' }} />      
          {true && (
            <div style={{ height: "40vh" }}>
              <div
                className="memberRight-custom-style text-center"
                style={{ letterSpacing: "15px" }}
              >
                <div className="w-100 text-center memberRight-title-words">
                  <img
                    src={ImageKing}
                    alt="king"
                    className="memberRight-image"
                  />
                  <b>升級權益</b>
                  <br />
                  <b>服務更周到!</b>
                </div>
              </div>
              <div>
                <Card className="memberRight-cardo mt-4 shadow ">
                  <div className="d-flex flex-column align-items-start justify-content-between p-3 m-3 mx-auto">
                    <div className="memberRight-card-passage">
                      ➕<b>線上預約保養</b>
                    </div>
                    <div className="memberRight-card-passage">
                      <b>➕LINE定期保養提醒</b>
                    </div>
                  </div>
                </Card>
              </div>
            </div>
          )}
        </Container>
      </section>
      {true && ( // 仅在当前页面为1时渲染section 2
        <section
          className="page section2"
          
        >
          <div className="mt-3 memberRight-listwords" style={{ width: "90%" }}>
            <p>
              感謝您成為元大的會員。為了保障您的權益，請仔細閱讀以下注意事項：
            </p>
            <ol>
              <li>
                <p>
                  會員資格限制：
                  <b style={{ color: "red" }}>每間診所僅可申請一個會員帳號</b>
                  ，為確保每位會員能充分享有我們提供的服務。因此申請時請確認所提供的信息真實有效。
                </p>
              </li>
              <li>
                <p>
                  會員等級：若僅進行一般註冊動作之診所將由系統預設為一般訪客身分，需擁有元大產品並登錄有效之產品機器號碼方能自動升級為正式會員。
                </p>
              </li>
              <li>
                <p>
                  帳號使用規範：
                  <b style={{ color: "red" }}>
                    每個會員帳號僅限於一台設備登入使用
                  </b>
                  。若您需要更換設備，請先登出舊設備，否則可能無法正常使用服務。
                </p>
              </li>
              <li>
                <p>
                  預約保養服務：僅提供給已登錄過元大產品序號之正式會員使用。若一般訪客需進行預約保養，請直接聯繫客服人員。
                </p>
              </li>
              <li>
                <p>
                  個人信息保護：您的個人信息將受到保護，僅用於維修預約、查詢產品購買紀錄等相關會員服務。我們不會將您的信息透露給第三方。
                </p>
              </li>
              <li>
                <p>
                  客戶服務：若有任何疑問或需要進一步了解會員權益，歡迎隨時聯繫我們。我們將竭誠為您提供協助。
                </p>
              </li>
            </ol>
          </div>
          {true && ( // not ouside params
            <div className="d-flex justify-content-start align-items-start w-75 mt-2">
              <p
                className="h3"
                onClick={() => {window.location.href = "/main";}}
              >
                <b style={{color: "red"}}>退出</b>
              </p>
            </div>
          )}
        </section>
      )}
    </>
  );
};

export default MemberRight;
